import type { FunctionComponent } from "react";
import { Button, Text } from "@kanda-libs/ks-design-library";
import {
  BANNER_SKELETONS,
  CLASS_NAMES,
} from "components/shared/InfoBanner/constants";
import { useHistory } from "react-router-dom";

export interface InfoBannerProps {
  title?: string;
  icon?: JSX.Element;
  nameContent?: JSX.Element;
  search?: JSX.Element;
  backArrow?: boolean;
  isLoading?: boolean;
  children?: JSX.Element;
}

const InfoBanner: FunctionComponent<InfoBannerProps> = function ({
  title,
  icon,
  nameContent,
  search,
  backArrow = true,
  isLoading = false,
  children,
}) {
  const { goBack } = useHistory();
  return (
    <div className={CLASS_NAMES.container}>
      <div className={CLASS_NAMES.nameContainer}>
        <div className={CLASS_NAMES.backArrowContainer}>
          {backArrow && (
            <Button.Icon
              id="info-banner-back-arrow"
              icon="arrow-left"
              onClick={() => {
                goBack();
              }}
            />
          )}
        </div>
        <div className={CLASS_NAMES.header}>
          <div className={CLASS_NAMES.titleWrapper}>
            <Text
              className={CLASS_NAMES.title}
              isLoading={isLoading}
              text={title}
              skeletonProps={BANNER_SKELETONS.title}
            />
            {!isLoading && icon}
            {search}
          </div>
          {nameContent && (
            <div className={CLASS_NAMES.nameContent}>{nameContent}</div>
          )}
        </div>
      </div>

      {children}
    </div>
  );
};

export default InfoBanner;
